import { render, staticRenderFns } from "./ModalDownloadPdf.vue?vue&type=template&id=6a4d47bc&scoped=true&lang=pug"
import script from "./ModalDownloadPdf.vue?vue&type=script&lang=js"
export * from "./ModalDownloadPdf.vue?vue&type=script&lang=js"
import style0 from "./ModalDownloadPdf.vue?vue&type=style&index=0&id=6a4d47bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4d47bc",
  null
  
)

export default component.exports